export default "__VITE_ASSET__B2yz_7kD__"